module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0120.png.0a72d3cf.jpg";